export type TenantContaminationRow = {
  id: string;
  name: string;
  nrLoads: number;
  contaminatedWeight: number;
  contaminationRate: number;
};

export enum SortKey {
  NAME = "name",
  NR_LOADS = "nrLoads",
  CONTAMINATED_WEIGHT = "contaminatedWeight",
  CONTAMINATION_RATE = "contaminationRate",
}

export enum SortDir {
  ASC = "asc",
  DESC = "desc",
}
